'use client'

import { useSession } from 'next-auth/react'

import { useUserProfile } from '../../hooks/useUserProfile'

import { useSignOutWithBootstrapPurge } from '@/features/auth'
import { useModalContext } from '@/shared/contexts/Modal'
import {
  Card,
  CardHeader,
  CardTitle,
  CardFooter
} from '@/shared/ui/Card'
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalTitle,
  ModalFooter,
  ModalDescription
} from '@/shared/ui/Modal'

import { UserProfileEditModal } from './EditModal'
import { UserProfileFooterActions } from './FooterActions'
import { MyProfileBody } from './MyProfileBody'

type MyProfileVariant = 'modal' | 'card'

interface MyProfileContentProps {
  variant: MyProfileVariant
}

export function MyProfileContent({ variant }: MyProfileContentProps) {
  const { data: session } = useSession()
  const { openModal } = useModalContext()
  const { signOut } = useSignOutWithBootstrapPurge()

  const { userProfile, refetchUserProfile } = useUserProfile({
    userUid: session?.user?.uid,
    me: true
  })

  const displayName =
    userProfile?.name ??
    (session?.user as { name?: string } | undefined)?.name ??
    'Carregando...'

  const handleEditProfile = () => {
    openModal({ modal: UserProfileEditModal, onSave: refetchUserProfile })
  }

  const handleSignOut = () => {
    signOut()
  }

  const body = (
    <MyProfileBody
      userProfile={userProfile ?? null}
      currentUserUid={session?.user?.uid ?? ''}
      displayName={displayName}
    />
  )

  const footer = (
    <UserProfileFooterActions
      itsMe
      onEditProfile={handleEditProfile}
      onSignOut={handleSignOut}
      userUid={session?.user?.uid ?? ''}
    />
  )

  if (variant === 'modal') {
    return (
      <Modal className="sm:max-w-lg" asCard>
        <ModalHeader>
          <ModalTitle>Perfil de Usuário</ModalTitle>
        </ModalHeader>
        <ModalDescription className="hidden">
          Detalhamento do perfil de {displayName}
        </ModalDescription>
        <ModalBody>{body}</ModalBody>
        <ModalFooter>{footer}</ModalFooter>
      </Modal>
    )
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Perfil de Usuário</CardTitle>
      </CardHeader>
      {body}
      <CardFooter>{footer}</CardFooter>
    </Card>
  )
}
